import {
  MOMENCE_EMBED_URL,
  MOMENCE_EMBED_HTML,
  MOMENCE_SCHEDULE_URL,
} from "./momence-config.js";

let pendingEmbedUrl = MOMENCE_EMBED_URL;

function getEmbedElements() {
  return {
    container: document.getElementById("momence-plugin-root"),
    frameWrap: document.getElementById("momence-embed-frame-wrap"),
    frame: document.getElementById("momence-embed-frame"),
    placeholder: document.getElementById("momence-embed-placeholder"),
    fallback: document.getElementById("momence-embed-fallback"),
  };
}

function mountOfficialEmbed(container) {
  if (!MOMENCE_EMBED_HTML || !container) return false;

  container.innerHTML = MOMENCE_EMBED_HTML;
  container.hidden = false;

  const { frameWrap, placeholder } = getEmbedElements();
  if (frameWrap) frameWrap.hidden = true;
  if (placeholder) placeholder.hidden = true;

  return true;
}

export function revealEmbed(url) {
  const { frameWrap, frame, placeholder } = getEmbedElements();
  if (!frameWrap || !frame) return;

  const targetUrl = url || pendingEmbedUrl || MOMENCE_EMBED_URL;
  pendingEmbedUrl = targetUrl;

  if (frame.src !== targetUrl) {
    frame.src = targetUrl;
  }

  frameWrap.hidden = false;
  if (placeholder) placeholder.hidden = true;
}

export function setEmbedUrl(url) {
  if (!url) return;
  pendingEmbedUrl = url;
}

export function initMomenceEmbed() {
  const { container, fallback } = getEmbedElements();

  if (mountOfficialEmbed(container)) {
    if (fallback) fallback.href = MOMENCE_SCHEDULE_URL;
    return;
  }

  if (fallback) {
    fallback.href = MOMENCE_SCHEDULE_URL;
  }
}
